/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

export const AuthContext = React.createContext({
  authInitialized: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setAuthInitialized: (value: boolean) => {},
});
